/*eslint-disable*/
import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
// import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import ToastMessage from '../../components/ToastMessage';
import Key from '../../clientVariables.json';

const UpdateCompanyContact = (props) => {
  const { contactDetails, handleEditContactClose, getCOmpanyContacts } = props;
  const formikRef = useRef();
  const [editContactName, setEditContactName] = useState(
    contactDetails?.EMP_CONTACT_NAME !== undefined &&
      contactDetails?.EMP_CONTACT_NAME !== null &&
      contactDetails?.EMP_CONTACT_NAME !== ''
      ? contactDetails?.EMP_CONTACT_NAME
      : ''
  );
  const [editContactRole, setEditContactRole] = useState(
    contactDetails?.EMP_DECL_TITLE !== undefined &&
      contactDetails?.EMP_DECL_TITLE !== null &&
      contactDetails?.EMP_DECL_TITLE !== ''
      ? contactDetails?.EMP_DECL_TITLE
      : ''
  );
  const [editContactEmail, setEditContactEmail] = useState(
    contactDetails?.EMP_CONTACT_EMAIL !== undefined &&
      contactDetails?.EMP_CONTACT_EMAIL !== null &&
      contactDetails?.EMP_CONTACT_EMAIL !== ''
      ? contactDetails?.EMP_CONTACT_EMAIL
      : ''
  );
  const [editLinkedinURL, setEditLinkedinURL] = useState(
    contactDetails?.EMP_LINKEDIN_URL !== undefined &&
      contactDetails?.EMP_LINKEDIN_URL !== null &&
      contactDetails?.EMP_LINKEDIN_URL !== ''
      ? contactDetails?.EMP_LINKEDIN_URL
      : ''
  );
  const [editContactPhone, setEditContactPhone] = useState(
    contactDetails?.EMP_CONTACT_PHONE !== undefined &&
      contactDetails?.EMP_CONTACT_PHONE !== null &&
      contactDetails?.EMP_CONTACT_PHONE !== ''
      ? contactDetails?.EMP_CONTACT_PHONE
      : ''
  );
  const [editContactPopup, setEditContactPopup] = useState(false);

  useEffect(() => {
    setEditContactPopup(true);
  }, []);

  // const updateContact = (contact) => {
  //   console.log(contact, editLinkedinURL);
  //   try {
  //     axios
  //       .post(`${Key.domain}/company/update_contact_`, {
  //         contactID: contact.ID,
  //         companyID: contact.COMPANY_ID,
  //         name: editContactName,
  //         role: editContactRole,
  //         email: editContactEmail,
  //         phone: editContactPhone,
  //         linkedinURL: editLinkedinURL,
  //       })
  //       .then((res) => {
  //         console.log(res);
  //         handleEditContactClose(false);
  //         setEditContactPopup(false);
  //         if (res.data.success === 1) {
  //           const msg = 'Contact Updated Successfully';
  //           toast(<ToastMessage message={msg} />);
  //           const offset = 0;
  //           getCOmpanyContacts(contact.COMPANY_ID, offset);
  //         }
  //       });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const updateContact = (fields) => {
    console.log(fields);
    try {
      axios
        .post(`${Key.domain}/company/update_contact_`, {
          contactID: contactDetails.ID,
          companyID: contactDetails.COMPANY_ID,
          name: fields.contactname,
          role: fields.designation,
          email: fields.email,
          phone: fields.mobile,
          linkedinURL: fields.linkedInUrl,
        })
        .then((res) => {
          console.log(res);
          handleEditContactClose(false);
          setEditContactPopup(false);
          
          if (res.data.success === 1) {
            const offset = 0;
          getCOmpanyContacts(contactDetails?.COMPANY_ID, offset);
            const msg = 'Contact Updated Successfully';
            toast(<ToastMessage message={msg} />);
          }
        });
    } catch (error) {
      console.error(error);
    }
  };
  const handleClose = () => {
    handleEditContactClose(false);
    setEditContactPopup(false);
  };

  return (
    <div>
      {/* UpdateCompanyContact */}
      {/* Edit contact modal */}
      <Modal
        size="md"
        show={editContactPopup}
        onHide={() => handleClose()}
        centered
        // style={{ marginLeft: "8%", marginTop:"100px"}}
        style={{ paddingTop: '80px' }}
      >
        <Modal.Header closeButton>
          Update Contact for{' '}
          <span style={{ fontWeight: 600, marginLeft: '5px' }}>{contactDetails.EMP_CONTACT_NAME}</span>
        </Modal.Header>

        <Modal.Body>
          {/* <Container>
            <Form>
              <Form.Group>
                <Form.Label className="mb-0 fw-bold">Name</Form.Label>
                <Form.Control
                  className="mb-2"
                  type="text"
                  placeholder="Enter name"
                  name="name"
                  onChange={(e) => {
                    console.log(e.target.value);
                    setEditContactName(e.target.value);
                  }}
                  value={editContactName}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="mb-0 fw-bold">Designation</Form.Label>
                <Form.Control
                  className="mb-2"
                  type="text"
                  placeholder="Enter contact role"
                  name="role"
                  onChange={(e) => setEditContactRole(e.target.value)}
                  value={editContactRole}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="mb-0 fw-bold">Email</Form.Label>
                <Form.Control
                  className="mb-2"
                  type="text"
                  placeholder="Enter email"
                  name="email"
                  onChange={(e) => setEditContactEmail(e.target.value)}
                  value={editContactEmail}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="mb-0 fw-bold">Linkedin URL</Form.Label>
                <Form.Control
                  className="mb-2"
                  type="text"
                  placeholder="Enter Linkedin url"
                  name="linkedin"
                  onChange={(e) => setEditLinkedinURL(e.target.value)}
                  value={editLinkedinURL}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="mb-0 fw-bolder">Mobile</Form.Label>
                <Form.Control
                  className="mb-2"
                  type="text"
                  placeholder="Enter phone number"
                  name="mobile"
                  onChange={(e) => setEditContactPhone(e.target.value)}
                  value={editContactPhone}
                />
              </Form.Group>

              <Button
                style={{ float: 'right', marginTop: '10px' }}
                onClick={(e) => {
                  // addContactSubmit();
                  updateContact(contactDetails);
                }}
              >
                Update
              </Button>
            </Form>
          </Container> */}
          <Formik
            innerRef={formikRef}
            initialValues={{
              contactname: editContactName,
              email: editContactEmail,
              mobile: editContactPhone,
              linkedInUrl: editLinkedinURL,
              designation: editContactRole,
            }}
            validationSchema={Yup.object().shape({
              contactname: Yup.string().required('Contact Name is required').matches(
                /^[a-zA-Z\s.]+$/,
                // /^[a-zA-Z0-9\s.+-]+$/,
                "Contact name invalid "
            ),
              email: Yup.string().email('Email is invalid').required('Email is required'),
              designation: Yup.string().required('Role is required'),
            })}
            onSubmit={(fields) => {
              console.log(fields);
              updateContact(fields);
            }}
            render={({ errors, status, touched, values, handleChange }) => (
              <div className="container">
                <Form autoComplete="off">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group" id="_form-group">
                        <label>
                          Contact Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Field
                         
                          name="contactname"
                          type="text"
                          placeholder="Contact Name"
                          className={'form-control mb-2' + (errors.contactname && touched.contactname ? ' is-invalid' : '')}
                        />
                        <ErrorMessage name="contactname" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group" id="_form-group">
                        <label>
                          Email <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Field
                          name="email"
                          type="text"
                          placeholder="Email"
                          className={'form-control mb-2' + (errors.email && touched.email ? ' is-invalid' : '')}
                        />
                        <ErrorMessage name="email" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group" id="_form-group">
                        <label>
                          Role <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Field
                          name="designation"
                          type="text"
                          placeholder="Role"
                          className={'form-control mb-2' + (errors.designation && touched.designation ? ' is-invalid' : '')}
                        />
                        <ErrorMessage name="designation" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group" id="_form-group">
                        <label>Mobile</label>
                        <Field
                          name="mobile"
                          type="text"
                          placeholder="xxxxxxxxxx"
                          className={'form-control mb-2' + (errors.mobile && touched.mobile ? ' is-invalid' : '')}
                        />
                        <ErrorMessage name="mobile" component="div" className="invalid-feedback" />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group" id="_form-group">
                        <label>LinkedIn URL</label>
                        <Field
                          name="linkedInUrl"
                          type="text"
                          placeholder="Linkedin URL"
                          className={'form-control mb-2' + (errors.linkedInUrl && touched.linkedInUrl ? ' is-invalid' : '')}
                        />
                        <ErrorMessage name="linkedInUrl" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <br />
                    <Button
                      variant="Primary"
                      type="submit"
                      style={{ background: 'blue', color: '#ffff', marginRight: '30px' }}
                    >
                      Update
                    </Button>
                  </div>
                </Form>
              </div>
            )}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UpdateCompanyContact;
